import { OptionInterface } from '../models';
import { AmPmEnum } from '../enums';

export const weekDaysOptions: OptionInterface[] = [
    {
        value: 0,
        description: 'Sunday',
    },
    {
        value: 1,
        description: 'Monday',
    },
    {
        value: 2,
        description: 'Tuesday',
    },
    {
        value: 3,
        description: 'Wednesday',
    },
    {
        value: 4,
        description: 'Thursday',
    },
    {
        value: 5,
        description: 'Friday',
    },
    {
        value: 6,
        description: 'Saturday',
    }
];
export const monthDaysOptions: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
export const hoursOptions: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
export const ampmOptions: string[] = [AmPmEnum.AM, AmPmEnum.PM];
